"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  orgnizationinfos: {
    index: '序号',
    orgId: '部门编码',
    orgCode: '部门代码',
    orgName: '部门名称',
    pntOrgIdName: '所属部门名称',
    pntOrgId: '所属部门',
    companyName: '公司名称',
    company: '公司',
    orgType: '部门类别',
    cmt: '状态',
    cosConId: '集团编码',
    ordprefix: '调令抬头',
    fleet: '船队',
    fleet2: '管理船队2',
    userange: '通用',
    universal: '通用',
    shoreBase: '岸基',
    boatPipe: '船管',
    telephone: '电话',
    fax: '传真',
    zipCode: '邮编',
    orgAddr: '地址',
    orgIcon: '图标',
    orgename: '英文名称',
    orgeaddr: '英文地址',
    owner: '船东名称',
    isexternal: '差旅支付公司',
    createDate: '创建时间',
    remark: '备注',
    add: '新增',
    del: '删除',
    edit: '编辑',
    print: '输出',
    table: '表格',
    stamp: '打印',
    crewManagement: '船员管理',
    crewPoolMaintenance: '船员池维护',
    submitted: '已提交',
    unSubmitted: '未提交',
    hint: '提示',
    confirm: '确定',
    cancel: '取消',
    delSuc: '删除成功',
    delFail: '删除失败',
    delCancel: '已取消删除',
    selectOneData: '请选择至少一条数据',
    crewPoolData: '船员池数据',
    save: '保存',
    submit: '提交',
    yes: '是',
    no: '否',
    goBack: '退回',
    basicInfo: '基础信息',
    operateInfo: '操作信息',
    createInfo: '创建信息',
    modifyInfo: '修改信息',
    submitInfo: '提交信息',
    message1: '请选择需要删除的行',
    message2: '此操作将永久删除该条数据',
    message3: '系统可能不会保存您所做的更改',
    message4: '请填写部门代码',
    message5: '请填写部门名称',
    message6: '请填写正确的手机号',
    message7: '保存成功',
    message8: '保存失败',
    message9: '异常',
    message10: '关闭窗口',
    message11: '请填写正确的邮编',
    message12: '请填写部门类别',
    message13: '不可删除已提交数据'
  }
};